
import "./loading.css";

export default function Loading({text}) {
  return (
    <div className="loadingComponent">
        <h1 dir='rtl'>{text}</h1>
        <div className='spinner'>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
  )
}
